/**
 * Created by Mikhail Menshenin on 28.10.2025
 */

GameSceneComponent.prototype.onSceneLoaded = cleverapps.extendFunc(GameSceneComponent.prototype.onSceneLoaded, function () {
    this._super();

    this.gameStatsView = new GameStatsView();
});

GameSceneComponent.prototype.onDestroy = cleverapps.extendFunc(GameSceneComponent.prototype.onDestroy, function () {
    if (this.gameStatsView) {
        this.gameStatsView.remove();
        this.gameStatsView = undefined;
    }

    this._super();
});
